<template>
  <NavBar :app-webview="appWebview"/>
  <DosePrice :app-webview="appWebview"/>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import DosePrice from "@/components/DosePrice.vue";
import NavBar from "@/components/NavBar.vue";
import "@/assets/style.scss"

export default defineComponent({
  name: 'Prisberegner dosispakket medicin',
  components: {
    NavBar,
    DosePrice
  },
  data: () => {
    return {
      appWebview: false
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.appWebview = urlParams.get('app-webview') !== null;
  }
});
</script>

<style lang="scss">
html, body {
  height: 100%;
}

#app {
  min-height: 100%;
  background-color: $color-bg;
  border-top-right-radius: 24px;
  border-top-left-radius: 24px;
}

.clickable {
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  color: $color-brand;
  line-height: 28px;
}

a {
  text-decoration: none;
  font-weight: bold;
}

table {
  margin-bottom: 4px;

  td {
    padding: 4px 48px 4px 0;

    &:first-of-type {
      font-weight: bold;
      color: $color-december;
    }
  }
}
</style>
